export default __webpack_public_path__ + "static/media/social12.20cbca01.jpg";